"use client"

import { NftMoleculeReatom } from "@/app/nft/store/nft-store.reatom"
import { usePercentage } from "@/app/percentage/utils"
import { Trans } from "@lingui/react/macro"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

export function NftRoyaltyReatom() {
  return (
    <ErrorBoundary
      fallback={
        <span>
          <Trans>N/A</Trans>
        </span>
      }
    >
      <Suspense fallback={<Skeleton className="h-5 w-4" />}>
        <RoyaltyViewReatom />
      </Suspense>
    </ErrorBoundary>
  )
}

const RoyaltyViewReatom = reatomComponent(() => {
  const { nftRoyaltyQueryParamsAtom } = useMolecule(NftMoleculeReatom)

  // Get query params from atom and use with TanStack Query
  const queryParams = nftRoyaltyQueryParamsAtom()
  const {
    data: { royalty },
  } = useSuspenseQuery(queryParams)

  const percentage = usePercentage(royalty)

  return <span>{percentage}</span>
})
